import MigrateTabsLayout from './MigrateTabsLayout.vue';
import Export from './Export.vue';
import Import from './Import.vue';

const rootRoute = {
  path: 'migrate',
  name: 'Migrate',
  component: MigrateTabsLayout,
  redirect: { name: 'IQTools.Migrate.Export' },
  meta: {
    auth: true,
    permissioned: true,
    basePath: '/iqtools/migrate',
  },
  children: [
    {
      path: 'export',
      name: 'IQTools.Migrate.Export',
      component: Export,
      meta: {
        auth: true,
        label: 'Export',
        permissionAlias: '/iqtools/migrate',
      },
    },
    {
      path: 'import',
      name: 'IQTools.Migrate.Import',
      component: Import,
      meta: {
        auth: true,
        label: 'Import',
        permissionAlias: '/iqtools/migrate',
      },
    },
  ],
};

export default rootRoute;
